import { mockContact } from '@/mocks/homeData';

const FORM_URL = 'https://readdy.ai/api/form/d9ku698h9dsfbuoi6kag';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {mockContact.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              {mockContact.description}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            <div className="flex flex-col gap-5">
              {[
                { label: '商务合作邮箱', value: mockContact.email, icon: 'ri-mail-line' },
                { label: '官方微信公众号', value: mockContact.wechat, icon: 'ri-wechat-line' },
                { label: '官方QQ群', value: mockContact.qq, icon: 'ri-qq-line' },
              ].map((info, idx) => (
                <div key={idx} className="flex items-center gap-4 p-4 bg-background-100 rounded-xl border border-background-200/70">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${info.icon} text-lg`}></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs text-foreground-500 mb-0.5">{info.label}</div>
                    <div className="text-sm md:text-base font-medium text-foreground-950 break-all">{info.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-7">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-4">
                给我们留言
              </h3>
              <form
                action={FORM_URL}
                method="POST"
                data-readdy-form=""
                className="flex flex-col gap-4"
              >
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    required
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="你的邮箱"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    required
                  />
                </div>
                <div>
                  <textarea
                    name="message"
                    placeholder="写下你想说的话..."
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    required
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                </div>
                <div className="honeypot-field">
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <button
                  type="submit"
                  className="w-full py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  发送留言
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}